import { Component, OnInit } from '@angular/core';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {Router} from "@angular/router";

@Component({
  selector: 'app-reports-summary',
  templateUrl: './reports-summary.component.html',
  styleUrls: ['./reports-summary.component.scss']
})
export class ReportsSummaryComponent implements OnInit {
  isLoading: boolean;
  reports = [];
  gaugeType: any;
  threshold1: any;
  threshold2: any;
  threshold3: any;

  constructor(public router: Router, private commonService: CommonService, public toastMessagesService: ToastMessagesService) {
    this.gaugeType = 'full';
    this.threshold1 = {0: {color: 'green'}};
    this.threshold2 = {0: {color: 'red'}};
    this.threshold3 = {0: {color: 'orange'}};

    this.isLoading = true;
  }

  async ngOnInit() {
    await this.initForms();
  }


  async initForms() {
    try {
      const result = await this.commonService.getList(`statistics/reports`);
      this.reports = result.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  getAcceptedNumber() {
    const reports = this.reports.filter(report => report.question_value === 1);
    return reports.length;
  }

  getDeniedNumber() {
    const reports = this.reports.filter(report => report.question_value === 0);
    return reports.length;
  }

  getNoResponseNumber() {
    const reports = this.reports.filter(report => report.question_value === -1);
    return reports.length;
  }

  async navigateToReports() {
    await this.router.navigate(['home/reports']);
  }
}
